import { Component } from "@angular/core";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";

@Component({
    selector: C.EWIZ_MAPPING_OPTIONS_DETAILS,
    templateUrl: "./mapping-options-details.component.html",
    standalone: false
})
export class EWizMappingOptionsDetailsComponent extends EWizDynamicBaseClassComponent {}
